<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<p class="first" style="text-align: center;">
	Diversion Books<br/>
	A Division of Diversion Publishing Corp.<br/>
	443 Park Avenue South, Suite 1008<br/>
	New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="sectiontop" style="text-align: center;">
	Copyright © 1980 by Becky Lee Weyrich<br/>
	All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="sectiontop" style="text-align: center;">
	This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="sectiontop" style="text-align: center;">
	For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p class="sectiontop" style="text-align: center;">
	First Diversion Books edition June 2014<br/>
	ISBN: <span style="font-family: 'Liberation Serif', serif; font-size: 1em; line-height: 1.375; text-align: justify;">978-1-62681-336-6</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<h1>
	Also by Becky Lee Weyrich</h1>
<p class="sectiontop" style="text-align: center;">
<span href="#/chap262649" title="Link target outside of Sample">Swan’s Way<br/>
	Savannah Scarlett<br/>
	Rainbow Hammock<br/>
	Captive of Desire<br/>
	Sands of Destiny<br/>
	The Scarlet Thread<br/>
	Once Upon Forever<br/>
	Summer Lightning<br/>
	Silver Tears<br/>
	Tainted Lilies<br/>
	Almost Heaven<br/>
	Whispers in Time<br/>
	Sweet Forever<br/>
	Rapture’s Slave<br/>
	Gypsy Moon<br/>
	Hot Winds from Bombay<br/>
	The Thistle and the Rose<br/>
	Forever, For Love</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<p class="sectiontop" style="text-align: center;">
<em>For Hank<br/>
	With Love</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_xxxxxxxxxxxxx_Copyright.vue?6fd4b3fd